import ImageCarousel from "../../Components/Common/Carousel";
import EstandeSemImagem from "../../assets/images/estande_sem_imagem.png";
import DimensoesTable from "../ComponenteCompartilhado/DimensoesTable";
import ValoresTable from "../ComponenteCompartilhado/ValoresTable";
import CommercialModal from "../../Components/Common/ModalContatoComercial";

const SidebarEstandePadraoNovo = ({
  selectedEstandeInfo,
  setSelectedEstandeInfo,
  corPrincipal,
  isMobile,
  setOpenMobile,
  setOpenModal,
  whatsappPrincipal,
  nomeFeira,
  mensagemPadrao,
  openModalWhatsapp,
  setOpenModalWhatsapp,
  corSecundaria,
  onToggle,
  isOpen,
  exibirAviso,
  isVisualizacaoInterna
}) => {

  const contatoComercial = [];
    
  selectedEstandeInfo?.whatsapp.length > 0 ? (
    selectedEstandeInfo?.whatsapp.map((contato, index) => (
      contatoComercial.push(
        { nome: contato.nome, 
          whatsapp_principal: contato.whatsapp_principal != '' ? contato.whatsapp_principal : whatsappPrincipal
        }
      )
    ))) : contatoComercial.push(
      { 
        nome: "", 
        whatsapp_principal: whatsappPrincipal
      }
    );
  
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>
      {!!onToggle && (
        <div className={`sidebar-backdrop ${isOpen ? "is-visible" : ""}`} onClick={onToggle} />
      )}

      <div className="sidebar-header">
        {isMobile && (
          <button 
            onClick={() => {
              setOpenMobile(false);
              setSelectedEstandeInfo(null);
            }}
            style={{
              position: 'absolute',
              top: '-10px',
              right: '10px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              zIndex: 100,
              color: "white"
            }}
            aria-label="Fechar"
            title="Fechar"
          >
            ×
          </button>
        )}

        <div className="sidebar-topo-estande" style={{ background: corPrincipal}}>
          <div className="mt-2">
            <h3 style={{ color: 'white'}} >{selectedEstandeInfo?.nome || ""}</h3>
            <p style={{ color: 'white'}}>{selectedEstandeInfo?.pavilhao?.length > 0 ? selectedEstandeInfo.pavilhao[0].nome : ""}</p>
          </div>
        </div>
        </div>

        <div className="relative" style={{ padding: "10px" }}>
          <ImageCarousel 
            images={selectedEstandeInfo?.imagens || []} 
            defaultImage={EstandeSemImagem}
            corFundo={corPrincipal}
          />
      </div>

      <div className="sidebar-body">

        <DimensoesTable selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal} />

        {selectedEstandeInfo?.tags?.length > 0 && (
          <div style={{marginTop: "0.5rem" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px", color: "#464373" }}>
              INCLUSOS
            </h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {selectedEstandeInfo.tags.map((tag, index) => (
                <div key={index} style={{
                  background: "#4643737a",
                  borderRadius: "10px",
                  padding: "6px 12px",
                  minWidth: "fit-content"
                }}>
                  <p style={{ color: "#fff", fontSize: "12px", fontWeight: 500, marginBottom: 0, whiteSpace: "nowrap" }}>
                    {tag.nome}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedEstandeInfo?.observacao && (
          <div style={{marginTop: "0.5rem" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px", color: "#464373" }}>
              OBSERVAÇÕES
            </h3>
            <div style={{ background: "#f7f7f7", padding: "1rem", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.15) 1px 2px 2px 1px" }}>
              <p style={{ color: "#878A99", marginBottom: 0 }}>
                {selectedEstandeInfo.observacao}
              </p>
            </div>
          </div>
        )}

        {!selectedEstandeInfo.bloqueado && (
          selectedEstandeInfo?.valor_total_geral && (
            <div style={{ marginTop: "0.5rem" }}>
              <h3 style={{ fontSize: "14px", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px", color: "#464373" }}>
                VALOR TOTAL: {formatCurrency(selectedEstandeInfo?.valor_total_geral || 0)}
              </h3>
              <ValoresTable selectedEstandeInfo={selectedEstandeInfo} />
            </div>
          )
        )}

        <div style={{ display: "flex", gap: "10px", marginTop: "0.5rem", justifyContent: "center" }}>
          { !isVisualizacaoInterna && (
            <button
              onClick={() => setOpenModalWhatsapp(true)}
              type="button"
              className="btn btn-success"
              style={{ flex: 1 }}
            >
              Comercial
            </button>
          )}

          <button
            onClick={() => { 
              if (!selectedEstandeInfo.bloqueado) {
                setOpenModal(true); 
               // setOpenMobile(false); 
              }
              else {
                exibirAviso("Atenção", "Entre em contato com o comercial para mais informações sobre Reserva.");
              }
            }}
            type="button"
            className="btn btn-outline-success"
            style={{ flex: 1 }}
          >
            Reservar
          </button>
        </div>
      </div>

      {openModalWhatsapp && (

         <CommercialModal 
          isOpen={openModalWhatsapp} 
          onClose={() => setOpenModalWhatsapp(false)} 
          contacts={contatoComercial}
          nomeFeira={nomeFeira}
          corPrincipal="#25D366"
        />
      )}

   </div>
  );
};

export default SidebarEstandePadraoNovo;
